<template>
    <CRow>
        <CCol col="12">
            <CAlert :color="messageColor" closeButton :show.sync="dismissCountDownS" fade>{{ alertMessage }}
            </CAlert>
        </CCol>
		<CCol col="12">
			<CCard>
				<CCardHeader>
					<div class="row">
						<CCol sm="6" class="align-self-center">
							<strong>Scholarship</strong>
						</CCol>
						<CCol sm="6" class="align-self-center">
							<div class="text-sm-right mt-3 mt-sm-0">
                                <CButton
                                    color="primary"
                                    v-on:click="uploadRow"
                                    style="margin-right: 10px"
                                >
                                    Upload By User
                                </CButton>
                                <CButton
                                    color="primary"
                                    v-on:click="createTableRow"
                                    v-if="checkPermission('scholarship-create')"
                                    style="margin-right: 10px"
                                >
                                    {{ $lang.buttons.general.crud.create }}
                                </CButton>
                                <CButtonGroup class="file-export">
                                    <CButton color="secondary" disabled>
                                        {{ $lang.buttons.export.title }}
                                    </CButton>
                                    <CButton color="danger" v-c-tooltip="$lang.buttons.export.pdf"
                                        v-on:click="exports(this, 'pdf', module, 'withdrawalRequest')">
                                        <i class="fas fa-file-pdf"></i>
                                    </CButton>
                                    <VueJsonToCsv class="btn btn-success" v-c-tooltip="$lang.buttons.export.excel"
                                        :json-data="json_data" :labels="json_label" :csv-title="json_title">
                                        <i class="fas fa-file-excel"></i>
                                    </VueJsonToCsv>
                                </CButtonGroup>
                            </div>
                        </CCol>
                    </div>
                </CCardHeader>
                <CCardBody>
                    <v-server-table :url="module.api.list" :columns="columns" :options="options" :data="data"
                        ref="myTable">
                        <template #type="data">
                            {{ data.row.scholarshipTypeTitle.title }}
                        </template>
                        <template #users="data">
                            <span v-if="data.row.userType === 'DirectCandidate'">
                                {{ data.row.directCandidate.firstName }} {{ data.row.directCandidate.lastName }}
                            </span>
                            <span v-else>
                                {{ data.row.user.firstName }} {{ data.row.user.lastName }}
                            </span>
                        </template>

                        <template #educationLevel="data">
                            {{ data.row.educationLevelTitle.title }}
                        </template>
                        <template #isVerified="data">
                            <span :class="getVerifiedStatusClass(data.row.isVerified)">
                                {{ getVerifiedStatusLabel(data.row.isVerified) }}
                            </span>
                        </template>
                        <!-- <template #isActive="data">
                            <span :class="data.row.isActive ? 'text-success' : 'text-danger'">
                                {{ data.row.isActive ? 'Active' : 'Inactive' }}
                            </span>
                        </template> -->
                        <template #actions="data">
                            <CButton color="warning" v-c-tooltip="$lang.buttons.general.crud.view"
                                v-on:click="viewTableRow(data.row.id)" v-if="checkPermission('scholarship-view')">
                                <i class="fas fa-eye"></i>
                            </CButton>
                            <CButton color="success" v-c-tooltip="$lang.buttons.general.crud.edit"
                                v-on:click="editTableRow(data.row.id)"
                                v-if="checkPermission('scholarship-update') && [1, 2, 3, 7].includes(data.row.isVerified)">
                                <i class="fas fa-pencil-alt"></i>
                            </CButton>
                            <!-- <CButton
                                color="primary"
                                v-c-tooltip="'Mark as Verified'"
                                v-on:click="markAsVerified(data.row.id)"
                                v-if="checkPermission('scholarship-verify') && [1, 7].includes(data.row.isVerified) && isEndDateNotPast(data.row.endDate)">
                                <i class="fas fa-check-double"></i> </CButton> -->
                            <CButton color="info" v-c-tooltip="'Mark as Verified & Public'"
                                v-on:click="markAsPublic(data.row.id)"
                                v-if="checkPermission('scholarship-publish') && [1, 2, 7].includes(data.row.isVerified) && isEndDateNotPast(data.row.endDate)">
                                <i class="fas fa-bullhorn"></i>
                            </CButton>
                            <CButton color="dark" v-c-tooltip="'Reject'" v-on:click="rejectScholarship(data.row.id)"
                                v-if="checkPermission('scholarship-verify') && [1].includes(data.row.isVerified)">
                                <i class="fas fa-ban"></i>
                            </CButton>
                            <CButton color="danger" v-c-tooltip="$lang.buttons.general.crud.delete"
                                v-on:click="deletePopup(data.row.id)"
                                v-if="checkPermission('scholarship-delete') && [1, 2, 3, 7].includes(data.row.isVerified)">
                                <i class="fas fa-trash"></i>
                            </CButton>
                        </template>
                    </v-server-table>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { ServerTable } from "vue-tables-2";
import { scholarship, reportreason } from "/src/store/url.js";
import store from "../../store/store";
import { Mixin } from "/src/mixins/index.js";
import VueJsonToCsv from "vue-json-to-csv";
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(ServerTable, {}, false);
Vue.use(VueSweetalert2);
export default {
    name: "Scholarship",
    mixins: [Mixin],
    components: {
        VueJsonToCsv
    },
    data() {
        return {
            self: this,
            json_data: [],
            json_label: {},
            json_title: "",
            messageColor: "success",
            alertMessage: "",
            showAlert: false,
            dismissCountDown: false,
            dismissCountDownS: false,
            activePage: 1,
            module: scholarship,
            columns: this.$lang.scholarship.table.columns,
            data: [],
            options: {
                headings: this.$lang.scholarship.table.headings,
                sortable: ['title'],
                filterable: ['title']
            }
        };
    },
    mounted() {
        let self = this;
        store.commit('showLoader', false);
        self.dismissCountDown = 0;
        self.dismissCountDownS = 0;
        if (localStorage.getItem("showAlert") !== "") {
            this.setAlert(true);
        }
        this.setAlert(false);
        localStorage.setItem("showAlert", "");
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                if (route.query && route.query.page) {
                    this.activePage = Number(route.query.page);
                }
            },
        },
    },
    methods: {
        setAlert(value) {
            this.showAlert = value;
        },
        createTableRow() {
            this.$router.push({ name: "Scholarship Create" });
        },
        uploadRow() {
            const route = this.$router.resolve({ name: 'Scholarship Upload' });
            window.open(route.href, '_blank');
        },
		viewTableRow(item) {
			this.$router.push({path: `scholarship/view/${item}`});
		},
		rowClicked(item, index) {
			this.$router.push({path: `scholarship/view/${item}`});
		},
        editTableRow(item) {
            this.$router.push({ path: `scholarship/edit/${item}` });
        },
        pageChange(val) {
            this.$router.push({ query: { page: val } });
        },
        getRepeatLabel(value) {
            switch (value) {
                case 0: return "Per Day";
                case 1: return "Week";
                case 2: return "Month";
                case 3: return "Year";
                default: return "-";
            }
        },
        getVerifiedStatusLabel(status) {
            const statusMap = {
                1: 'Pending',
                2: 'Verified',
                3: 'Published',
                4: 'Rejected',
                5: 'Blocked',
                6: 'Expired',
                7: 'Draft'
            };
            return statusMap[status] || 'Unknown';
        },
        getVerifiedStatusClass(status) {
            switch (status) {
                case 1: return 'text-warning';  // Pending
                case 2: return 'text-success';  // Verified
                case 3: return 'text-primary';  // Published
                case 4: return 'text-danger';   // Rejected
                case 5: return 'text-dark';     // Blocked
                case 6: return 'text-muted';    // Expired
                case 7: return 'text-info';     // Draft
                default: return 'text-secondary'; // Unknown
            }
        },
        getStatusLabel(value) {
            switch (value) {
                case 0: return "Draft";
                case 1: return "Public";
                default: return "-";
            }
        },
        // Check if the end date is not past the current date
        isEndDateNotPast(endDateString) {
            if (!endDateString) {
                return false; // If no end date, assume it cannot be published (or handle as per business logic)
            }
            const endDate = new Date(endDateString);
            const currentDate = new Date();
            // Set both dates to the start of their day for fair comparison (ignore time)
            endDate.setHours(0, 0, 0, 0);
            currentDate.setHours(0, 0, 0, 0);
            return endDate >= currentDate; // True if end date is today or in the future
        },
        // "Mark as Verified"
        markAsVerified(scholarshipId) {
            this.$swal({
                title: 'Confirm Verification',
                text: 'Are you sure you want to mark this scholarship as Verified?',
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Verify it!',
                cancelButtonText: 'No, cancel',
            }).then((result) => {
                if (result.value) {
                    let self = this;
                    // API call to update status to 2 (Verified)
                    axios.post(`${this.module.api.updateStatus}`, { id: scholarshipId, status: 2 }) // 2 for 'Verify'
                        .then(response => {
                            if (response.data.code === 200) {
                                self.$refs.myTable.refresh();
                                self.alertMessage = response.data.message || 'Scholarship marked as Verified successfully!';
                                self.dismissCountDownS = 10;
                                self.messageColor = "success";
                            } else {
                                self.alertMessage = response.data.message || 'Failed to mark scholarship as Verified.';
                                self.messageColor = "danger";
                                self.dismissCountDownS = 10;
                            }
                        })
                        .catch(error => {
                            console.error('Error marking as verified:', error);
                            self.alertMessage = 'An error occurred while marking as Verified.';
                            self.messageColor = "danger";
                            self.dismissCountDownS = 10;
                        });
                }
            });
        },
        // "Mark as Public"
        markAsPublic(scholarshipId) {
            this.$swal({
                title: 'Are you sure?',
                text: 'Do you want to mark this scholarship as Public?',
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, publish it!',
                cancelButtonText: 'No, cancel',
            }).then((result) => {
                if (result.value) {
                    let self = this;
                    // Assuming you have a specific API endpoint for this action
                    // Example: module.api.publish (you'll need to define this in url.js)
                    // Or, you might update the existing scholarship with a new status
                    axios.post(`${this.module.api.updateStatus}`, { id: scholarshipId, status: 3 }) // 3 for 'Published'
                        .then(response => {
                            if (response.data.code === 200) {
                                self.$refs.myTable.refresh(); // Refresh the table to show updated status
                                self.alertMessage = response.data.message || 'Scholarship marked as Public successfully!';
                                self.dismissCountDownS = 10;
                                self.messageColor = "success";
                            } else {
                                self.alertMessage = response.data.message || 'Failed to mark scholarship as Public.';
                                self.messageColor = "danger";
                                self.dismissCountDownS = 10;
                            }
                        })
                        .catch(error => {
                            console.error('Error marking as public:', error);
                            self.alertMessage = 'An error occurred while marking as Public.';
                            self.messageColor = "danger";
                            self.dismissCountDownS = 10;
                        });
                }
            });
        },
        // "Reject Scholarship"
        async rejectScholarship(scholarshipId) {
            try {
                const response = await axios.post(reportreason.api.reasonsList, { type: 4 });
                if (response.data.code === 200) {
                    const reasons = response.data.data;
                    let optionsHtml = '<option value="">Select a reason</option>';
                    reasons.forEach(item => {
                        optionsHtml += `<option value="${item.id}">${item.title}</option>`;
                    });

                    const result = await this.$swal({
                        title: 'Reject Scholarship',
                        html:
                            '<div class="text-left"><label>Reason Title (Required)</label>' +
                            `<select id="swal-reject-title" class="form-control mb-3">${optionsHtml}</select>` +
                            '<label>Description (Optional)</label>' +
                            '<textarea id="swal-reject-description" class="form-control" placeholder="Type additional details here..." rows="3"></textarea></div>',
                        showCancelButton: true,
                        confirmButtonColor: '#d33',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: 'Yes, Reject it!',
                        cancelButtonText: 'Cancel',
                        focusConfirm: false,
                        preConfirm: () => {
                            const titleSelect = document.getElementById('swal-reject-title');
                            const rejectedId = titleSelect.value;
                            const rejectedTitle = titleSelect.options[titleSelect.selectedIndex].text;
                            const description = document.getElementById('swal-reject-description').value;
                            if (!rejectedId) {
                                this.$swal.showValidationMessage('You need to select a reason title!');
                                return false;
                            }
                            return { rejectedId, rejectedTitle, description };
                        }
                    });

                    if (result.value) {
                        const { rejectedId, description } = result.value;

                        const updateResponse = await axios.post(`${this.module.api.updateStatus}`, {
                            id: scholarshipId,
                            status: 4, // 4 for 'Rejected'
                            rejectedId: rejectedId,
                            rejectedReason: description
                        });

                        if (updateResponse.data.code === 200) {
                            this.$refs.myTable.refresh();
                            this.alertMessage = updateResponse.data.message || 'Scholarship rejected successfully!';
                            this.dismissCountDownS = 10;
                            this.messageColor = "success";
                        } else {
                            this.alertMessage = updateResponse.data.message || 'Failed to reject scholarship.';
                            this.messageColor = "danger";
                            this.dismissCountDownS = 10;
                        }
                    }
                } else {
                    this.alertMessage = 'Failed to load rejection reasons.';
                    this.messageColor = "danger";
                    this.dismissCountDownS = 10;
                }
            } catch (error) {
                console.error('Error rejecting scholarship:', error);
                this.alertMessage = 'An error occurred while rejecting the scholarship.';
                this.messageColor = "danger";
                this.dismissCountDownS = 10;
            }
        },
        deletePopup(item) {
            this.$swal({
                title: this.$lang.common.delete_swal.are_you,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#e55353",
                confirmButtonText: this.$lang.common.delete_swal.yes_delete,
                cancelButtonText: this.$lang.common.delete_swal.cancel,
            }).then((result) => {
                if (result.value) {
                    let self = this;
                    axios.delete(this.deleteUrlWeb(this.module, item), self).then(function (response) {
                        if (response.status === 200) {
                            self.$refs.myTable.refresh();
                            self.alertMessage = response.data.message;
                            self.dismissCountDownS = 10;
                            self.messageColor = "success";
                        } else {
                            self.$refs.myTable.refresh();
                            self.alertMessage = response.data.message;
                            self.messageColor = "danger";
                            self.dismissCountDownS = 10;
                        }
                    });
                }
            });
        }
    },
};
</script>

<style>
div .error {
    color: red;
}

.hasError label {
    color: red;
}
</style>